import { z } from 'zod';

import i18n from '@/i18n';

export const NameSchema = z.object({
    name: z.string({ message: i18n.global.t('Hetta er ein kravdur teigur.') }),
});
